import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Contrato } from '../entities/contrato.entity';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { MenudesktopComponent } from './menudesktop.component';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-menumobile',
  templateUrl: './menumobile.component.html'
})
export class MenumobileComponent implements OnInit {
  public static changeContrato: Subject<boolean> = new Subject();
  public currentUrl: string;
  public contratos: Contrato[];
  public positionselected: number;
  public UserName: string;
  public explo: string;
  public factText = 'factura';
  @Output() contratoenvio = new EventEmitter();
  @Output() public open = new EventEmitter();

  constructor(private sessionService: SessionService, private router: Router) {
    this.positionselected = this.sessionService.PosicionContratoSelected;
    MenumobileComponent.changeContrato.subscribe(res => {
      this.cargaDatos();
    });
  }

  ngOnInit() {
    this.cargaDatos();
  }

  public cargaDatos() {
    if (this.sessionService.contratos !== undefined) {
      this.explo = this.sessionService.datosExplotacion.Codigo.toUpperCase();
      if (this.explo === 'MELILLA') {
        this.factText = 'pre-factura';
      }
      this.UserName = this.sessionService.nombre;
      this.contratos = this.sessionService.contratos;
      if (this.sessionService.contratoSelected === undefined) {
        this.sessionService.contratoSelected = this.contratos[0];
        this.sessionService.PosicionContratoSelected = this.positionselected = 0;
      } else {
        this.positionselected = this.sessionService.PosicionContratoSelected;
      }
    }
  }

  lanzar(event) {
    this.open.emit({ abrir: true });
  }

  public ContratoSeleccionado(event) {
    this.sessionService.PosicionContratoSelected = this.positionselected;
    this.sessionService.contratoSelected = this.contratos[this.positionselected];
    this.contratoenvio.emit({ contratoSeleccionado: this.sessionService.contratoSelected });

    MenudesktopComponent.changeContrato.next(true);
  }

  public logout() {
    this.sessionService.logout();
    this.router.navigate(['public/login']);
  }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/menumobile.component.ts